const DEV = "https://api.darzaghouan.com/";
export default DEV;
